var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { html, css } from 'lit';
import { customElement, PIC, PICBase } from '../Internals';
import { classMap } from 'lit/directives/class-map.js';
let PICCard = class PICCard extends PICBase {
    set title_(iTitle) {
        this.title__ = iTitle;
        this.requestUpdate();
    }
    get title_() { return this.title__; }
    constructor() {
        super();
        this.dashedBorder = false;
        this.isFile = true;
        this.isinput__ = false;
    }
    static get styles() {
        const defaultStyle = css `
            .pic-card {
                /* Card (dp1) surface - one step above whatever dp0 background
                   it's sitting on (e.g. a modal body). In light mode this is
                   still white like the default browser background, so it's a
                   no-op there; in dark mode it lightens to --pic-surfaceColor
                   (#1e1e1e vs the page's #121212), which is what actually
                   separates the card from the modal now that a plain black
                   box-shadow barely reads against a near-black background. */
                background-color: var(--pic-surfaceColor, white);
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
                transition: 0.3s;
                border-radius: 1rem;
                /* min-width: 6rem;
                max-width: 10rem;
                min-height: 6rem;
                max-height: 10rem; */
                width: clamp(8rem, 20vw, 10rem);
                height: clamp(8rem, 20vw, 10rem);
                overflow: hidden;
            }

            .pic-card:hover {
                box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
            }

            .pic-card * {
                padding: 2px 16px;
            }

            .pic-cardtop {
                background-color: var(--headerColor, var(--pic-primaryColor));
                color: white;
                border-radius: 1rem 1rem 0 0;
                white-space: nowrap;
                padding-left: 0;
                text-align: center;
                max-width: 100%
            }

            .pic-card p {
                padding: 0.1rem;
                font-size: clamp(0.80rem, 2vw, 16px);
                text-overflow: ellipsis;

                /* Needed to make it work */
                overflow: hidden;
                white-space: nowrap;            
            }

            .pic-card .tabelement {
                margin: 0;
                padding-top: 0;
                padding-bottom: 0;
            }
            .slot-content{
                display: grid;
                align-items: center;
                justify-content: center;
            }

            /* HatchClerk */
            .picHatchClerk.pic-card {
                box-shadow: unset;
                transition: unset;
                border-radius: 4px;
                border: 1px solid var(--PIC-Outline, rgba(0, 0, 0, 0.12));
                padding: 0 8px;
                width: 148px;
                height: unset;
                box-sizing: border-box;
            }

            .picHatchClerk.pic-card:hover {
                box-shadow: unset;
            }

            .picHatchClerk.pic-cardtop {
                background-color: #ffffff;
                color: black;
                border-radius: 4px 4px 0 0;
                white-space: nowrap;
                text-align: center;
                max-width: 100%;
                padding: 8px;
                width: 148px;
            }

            .picHatchClerk.pic-card p {
                padding: 8px;
                font-size: 18px;
                text-overflow: unset;
                overflow: unset;
                white-space: nowrap;
                margin: 0px;
                text-align: center;   
            }

            .picHatchClerk.pic-cardtop.pic-h6{
                color: #3d3d3d;
                font-feature-settings: 'clig' off, 'liga' off;
                font-family: Quicksand;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px; /* 133.333% */
                letter-spacing: 0.15px;
                
                padding: 0;
                text-align: unset;
                border-radius: 0;
                /* white-space: nowrap; */
                max-width: unset;
                width: unset;
            }

            .picHatchClerk .slot-content {
                padding: 0px 8px;
                display: block;
            }
            .picHatchClerk.pic-card.dashedBorder {
                border-style: dashed;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    handleSlotChange(e) {
        if (this.isFile) {
            if (this.slots_.length > 0) {
                this.title_ = this.slots_[0].name_;
            }
        }
    }
    getClassMap() {
        return {
            'pic-cardtop': true,
            'pic-h6': PIC.getInstance.webVersion == '3',
            ['' + this.drawMode]: true,
        };
    }
    render() {
        return html `
        ${this.renderCSS(true)}
        <div .dom=${this} class="pic-card pic-selectable ${this.drawMode}${this.dashedBorder ? ' dashedBorder' : ''}">
            <div class=${classMap(this.getClassMap())}>
                <p title=${this.title_}>${this.title_}</p>
            </div>
            <slot @slotchange=${this.handleSlotChange} class="slot-content"></slot>
        </div>
        `;
    }
};
__decorate([
    query('slot')
], PICCard.prototype, "slot_", void 0);
__decorate([
    queryAssignedElements()
], PICCard.prototype, "slots_", void 0);
__decorate([
    property()
], PICCard.prototype, "drawMode", void 0);
PICCard = __decorate([
    customElement('pic-card')
], PICCard);
export { PICCard };
//# sourceMappingURL=PICCard.js.map